// src/components/ScrollingTicker.js
import React, { useContext, useState, useEffect } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";

const TEXT = {
  EN: [
    "TACTICAL & MILITARY GEAR",
    "PROFESSIONAL HUNTING EQUIPMENT",
    "FIELD-TESTED DURABILITY",
    "BUILT FOR MISSION & SURVIVAL",
    "DELIVERY ACROSS LEBANON",
  ],
  AR: [
    "معدات تكتيكية وعسكرية",
    "معدات صيد احترافية",
    "متانة مجرّبة في الميدان",
    "مصممة للمهام والبقاء",
    "توصيل إلى جميع المناطق اللبنانية",
  ],
};

// =============== ENGLISH TICKER ===============
function EnglishTicker({ items }) {
  return (
    <div className="ticker-container-en group">
      <div className="ticker-move-en">
        <div className="ticker-track-en">
          {items.map((text, i) => (
            <React.Fragment key={i}>
              <span
                className="
                  ticker-item
                  text-[#D6E5D9]
                  font-semibold
                  tracking-wide
                  drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)]
                "
              >
                {text}
              </span>
              {i !== items.length - 1 && (
                <span className="mx-4 text-[#2E5A2A]/80 font-bold">│</span>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Duplicate for seamless scrolling */}
        <div className="ticker-track-en">
          {items.map((text, i) => (
            <React.Fragment key={"dup" + i}>
              <span
                className="
                  ticker-item
                  text-[#D6E5D9]
                  font-semibold
                  tracking-wide
                  drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)]
                "
              >
                {text}
              </span>
              {i !== items.length - 1 && (
                <span className="mx-4 text-[#2E5A2A]/80 font-bold">│</span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

// =============== ARABIC TICKER ===============
function ArabicTicker({ items }) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;

    const id = setInterval(() => {
      setIndex((p) => (p + 1) % items.length);
    }, 3000);

    return () => clearInterval(id);
  }, [paused, items.length]);

  return (
    <div
      className="ticker-container-ar"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div key={index} className="ticker-ar-item">
        <span
          className="
            ticker-item
            text-[#D6E5D9]
            font-semibold
            tracking-wide
            drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)]
          "
          dir="rtl"
        >
          {items[index]}
        </span>
      </div>
    </div>
  );
}

function ScrollingTicker() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  const items = TEXT[lang];

  return (
    <div
      className="
        w-full
        bg-[#0F1A12]
        border-y border-[#2E5A2A]/50
        py-3 mb-6
        cursor-pointer
        hover:bg-[#0F1A12]/95
        transition
        active:scale-[0.99]
      "
      onClick={() => navigate("/all-products")}
      title={lang === "EN" ? "Explore All Products" : "تصفّح كل المنتجات"}
    >
      {lang === "EN" ? (
        <EnglishTicker items={items} />
      ) : (
        <ArabicTicker items={items} />
      )}
    </div>
  );
}

export default ScrollingTicker;
